import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/cluster/";

export default class ClusterApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getClusters(params) {
    return await request.post(`${rootRoute}getClusters`, {
      filter: params,
      parameters: {},
    });
  }
  async getCluster(id) {
    return await request.post(`${rootRoute}getClusters`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createCluster(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createCluster`, { data });
  }
  async deleteCluster(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteCluster`, { data });
  }
  async editCluster(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateCluster`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importCluster`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getClusterimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportCluster`, {
      filter: filter,
      format: format
    });
  }
}
